<template>
  <div class="rank-head" :class="colorType">
    <div class="ti">{{title}}</div>
    <div class="topNum">TOP&nbsp;&nbsp;{{topTxt}}</div>
  </div>
</template>

<script>
    export default {
      name: "RankHead",
      props:{
        title:{
          default:'飙升榜',
          type:String,
        },
        topTxt:{
          default:20,
          type:Number,
        },
      },
      computed:{
        colorType(){
          if(this.title === '飙升榜'){
            return 'color-yellow';
          }else if(this.title === '收藏榜'){
            return 'color-blue';
          }else if(this.title === '荐购榜'){
            return 'color-red';
          }else{
            return 'color-green';
          }
        },
      },
    }
</script>

<style lang="css" scoped>
.rank-head,.topNum{
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 100% 100%;
}
.rank-head{
  position: relative;
  width: 100%;
  height: 115px;
  padding-top: 40px;
  padding-left: 140px;
}
.ti{
  font-family: YouSheBiaoTiHei;
  font-size: 40px;
  font-weight: bold;
  font-style: italic;
}
.topNum{
  font-family: YouSheBiaoTiHei;
  position: absolute;
  right: 80px;
  bottom:0;
  width: 145px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  font-weight: bold;
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/pages/categry/components/RankHead.vue